/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * Payout
 * Payout application
 * OpenAPI spec version: 1.0
 */

export enum PayoutCommonOrderTraderOrderV1Priority {
    PRIORITY_UNSPECIFIED = 'PRIORITY_UNSPECIFIED',
    PRIORITY_HIGH = 'PRIORITY_HIGH',
    PRIORITY_MEDIUM = 'PRIORITY_MEDIUM',
    PRIORITY_LOW = 'PRIORITY_LOW',
}
